import { BASE_UI_URL } from '@americanexpress/arcade-core';

export const noNavbar = [
  { type: 'includes', path: `${BASE_UI_URL}/enroll` },
  { type: 'includes', path: `${BASE_UI_URL}/landing` },
  { type: 'includes', path: `${BASE_UI_URL}/explore/share` },
  { type: 'includes', path: `${BASE_UI_URL}/stamps/share` },
  { type: 'pattern', regex: `${BASE_UI_URL}/stamps/[a-zA-Z0-9-]+/share` },
];

export function shouldHideNavbar(pathName) {
  return noNavbar.some((route) => {
    if (route.type === 'includes') {
      return pathName.includes(route.path);
    }

    const regex = new RegExp(route.regex);
    return regex instanceof RegExp && regex.test(pathName);
  });
}

export default shouldHideNavbar;
